import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';
import App from './App.tsx';
import './index.css';

// Inicializar Google Analytics
ReactGA.initialize('G-NX1QHR78HQ');

createRoot(document.getElementById('root')!).render(<App />);
